export default __webpack_public_path__ + "static/media/5.2981436f.jpg";